var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PasoAsociacion",
    { attrs: { title: "Tipos de Actividad" } },
    [
      _c("v-divider"),
      _c("CabeceraTabla", {
        scopedSlots: _vm._u([
          {
            key: "izquierda",
            fn: function() {
              return [
                _c("BuscadorOperacionCrud", {
                  attrs: {
                    filter:
                      _vm.gridApi &&
                      _vm.gridApi.setQuickFilter.bind(_vm.gridApi)
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("TiposActividadGrid", {
        attrs: {
          readonly: _vm.modoVer,
          esEditar: _vm.modoEditar,
          value: _vm.value
        },
        on: {
          input: _vm.handleValueChange,
          gridApiChange: _vm.handleGridApiChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }